export default __webpack_public_path__ + "files/e86946484cc3e50985f1348ee7d5cf4c.svg";